import useUserPlanData from "@/components/Root/hooks/useUserPlanData";

import { useCheckoutDataQuery } from "@/components/Root/hooks/useCheckoutDataQuery";
import {
  LOCALISED_PRICING_SOURCE,
  useLocalisedPricing,
} from "./useLocalisedPricing";

// `useLocalisedPricing` with its signals already sourced, off page-wide cached
// queries, so callers that only need the answer don't re-plumb them.
export function useIsLocalisedPricing() {
  const { data: userPlanData, isFetched: isUserPlanFetched } =
    useUserPlanData();
  const { data: userCheckoutData, isFetched: isCheckoutFetched } =
    useCheckoutDataQuery();

  const localisedPricing = useLocalisedPricing({
    source: LOCALISED_PRICING_SOURCE.METADATA,
    planCurrency: userCheckoutData?.planCards?.[0]?.pricing.currency,
    userCountryCode: userPlanData?.country_code,
  });

  return {
    ...localisedPricing,
    // Until both signals land, `isLocalisedPricing` can read false for a localised user
    isResolved: isUserPlanFetched && isCheckoutFetched,
  };
}
